import apiFetch from '../apiFetch'

export default function (token, dossierId) {
  return apiFetch({ endPoint: `campaign/${dossierId}/GetAllCampaigns`, method: 'GET', token: token })
}
